var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<p data-class="viewOnly">\n	<button class="js-edit btn btn-link">Add new group</button>\n</p>\n\n<form class="form-mini boxed" data-class="editOnly">\n	<h1 class="title">Add new group</h1>\n	<div class="form-group">\n		<input type="text" class="form-control" name="GroupName" placeholder="Group name" />\n	</div>\n	<div class="form-group">\n		<button class="js-save btn">Create</button>\n		<button class="js-cancel btn btn-link btn-sm">Cancel</button>\n	</div>\n</form>';
}
return __p;
};
